import React from "react";
import { Table } from "antd";

import { columns } from "../lib/columns";
import "./paymentHistory.page.scss";
import { dataSource } from "../lib/dataSource";
import { dataController } from "../lib/tempDataController";
import { useDispatch, useSelector } from "react-redux";
import { payHistoryActions, selectPayHistory } from "Features/pay_history";

export const PaymentHistory = () => {
	const dispatch = useDispatch();

	const totalItems = useSelector(selectPayHistory.total);
	const reqParams = useSelector(selectPayHistory.params);
	const rawData = dataController();
	const data = dataSource(rawData);

	function onPageChange(page) {
		dispatch(payHistoryActions.changePage(page - 1));
	}

	return (
		<div className="pay-history">
			<div className="pay-history__title">Payment history</div>
			<Table
				className="pay-history__table"
				columns={columns}
				dataSource={data}
				scroll={{ y: window.innerHeight * 0.6 }}
				pagination={{
					pageSize: data.length,
					showSizeChanger: false,
					onChange: onPageChange,
					total: totalItems,
					current: reqParams.offset / 5 + 1,
				}}
			/>
		</div>
	);
};
